var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M762 942H262c-71.68 0-130-58.32-130-130V212c0-71.68 58.32-130 130-130h500c71.68 0 130 58.32 130 130v600c0 71.68-58.32 130-130 130zM262 142c-38.59 0-70 31.41-70 70v600c0 38.59 31.41 70 70 70h500c38.59 0 70-31.41 70-70V212c0-38.59-31.41-70-70-70H262z",
    fill: "#2c2c2c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M692 402H332c-38.59 0-70-31.41-70-70v-60c0-38.59 31.41-70 70-70h360c38.59 0 70 31.41 70 70v60c0 38.59-31.41 70-70 70zM332 262c-5.42 0-10 4.58-10 10v60c0 5.42 4.58 10 10 10h360c5.43 0 10-4.58 10-10v-60c0-5.42-4.57-10-10-10H332zM372 542h-60c-16.57 0-30-13.43-30-30s13.43-30 30-30h60c16.57 0 30 13.43 30 30s-13.43 30-30 30zM542 542h-60c-16.57 0-30-13.43-30-30s13.43-30 30-30h60c16.56 0 30 13.43 30 30s-13.44 30-30 30zM712 542h-60c-16.56 0-30-13.43-30-30s13.44-30 30-30h60c16.56 0 30 13.43 30 30s-13.44 30-30 30z",
    fill: "#2c2c2c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M372 672h-60c-16.57 0-30-13.44-30-30s13.43-30 30-30h60c16.57 0 30 13.44 30 30s-13.43 30-30 30zM542 672h-60c-16.57 0-30-13.44-30-30s13.43-30 30-30h60c16.56 0 30 13.44 30 30s-13.44 30-30 30zM712 672h-60c-16.56 0-30-13.44-30-30s13.44-30 30-30h60c16.56 0 30 13.44 30 30s-13.44 30-30 30z",
    fill: "#2c2c2c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M372 802h-60c-16.57 0-30-13.44-30-30s13.43-30 30-30h60c16.57 0 30 13.44 30 30s-13.43 30-30 30zM542 802h-60c-16.57 0-30-13.44-30-30s13.43-30 30-30h60c16.56 0 30 13.44 30 30s-13.44 30-30 30zM712 802h-60c-16.56 0-30-13.44-30-30s13.44-30 30-30h60c16.56 0 30 13.44 30 30s-13.44 30-30 30z",
    fill: "#2c2c2c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.a1b8ac8bd12fbaca10c1bb1b1dd3e401.svg";
export { ForwardRef as ReactComponent };